import { darken, getContrastRatio, lighten } from '@mui/material/styles';

// Prefer the brand color, adjusting its brightness only when it disappears
// against the surface (for example a pale brand in light mode).
export function getReadableButtonColor(color, surface) {
  if (getContrastRatio(color, surface) >= 4.5) return color;
  const adjust = getContrastRatio('#FFFFFF', surface) > getContrastRatio('#000000', surface) ? lighten : darken;
  for (let step = 1; step <= 20; step += 1) {
    const candidate = adjust(color, step / 20);
    if (getContrastRatio(candidate, surface) >= 4.5) return candidate;
  }
  return adjust(color, 1);
}

// A gradient must remain readable at both ends, including on hover.
export function getFilledButtonText(...backgrounds) {
  const minimumContrast = color => Math.min(...backgrounds.map(background => getContrastRatio(color, background)));
  if (minimumContrast('#FFFFFF') >= 4.5) return '#FFFFFF';
  if (minimumContrast('#111827') >= 4.5) return '#111827';
  return minimumContrast('#000000') > minimumContrast('#FFFFFF') ? '#000000' : '#FFFFFF';
}

export function getThemeButtonColor(theme, color = 'primary') {
  if (color === 'inherit') return 'inherit';
  return getReadableButtonColor((theme.palette[color] || theme.palette.primary).main, theme.palette.background.paper);
}
